import { toast } from "react-toastify";
import defaultErrorHandler from "actions/global/default-error-handler";
import {
  BIKE_TRIGGER_HISTORY_LOADING,
  BIKE_TRIGGER_HISTORY_ERROR,
  BIKE_TRIGGER_HISTORY_DELETE,
  BIKE_TRIGGER_HISTORY_SEARCH,
} from "./constants";
import { requestDelete } from "./requests";
import { requestCommonSearch } from "../common/requests";

export const setLoading = (status) => ({
  type: BIKE_TRIGGER_HISTORY_LOADING,
  payload: status
});

export const triggerDelete = (id) => dispatch => {
  dispatch(setLoading(true));
  requestDelete(id)
    .then(() => {
      dispatch({
        type: BIKE_TRIGGER_HISTORY_DELETE,
        payload: id
      });
      toast("Trigger removed successfully", {
        type: toast.TYPE.SUCCESS,
      });
    })
    .catch(error => {
      dispatch(setLoading(false));
      dispatch(defaultErrorHandler(error, BIKE_TRIGGER_HISTORY_ERROR));
    });
};

export const triggerSearch = (page = 0, size = 10, sort = "id,asc", filters = []) => dispatch => {
  dispatch(setLoading(true));
  requestCommonSearch("triggered-action", page, size, sort, filters)
    .then(response => {
      dispatch({
        type: BIKE_TRIGGER_HISTORY_SEARCH,
        payload: response
      });
    })
    .catch(error => {
      dispatch(setLoading(false));
      dispatch(defaultErrorHandler(error, BIKE_TRIGGER_HISTORY_ERROR));
    });
};



// WEBPACK FOOTER //
// ./src/actions/bike-trigger-history/actions.js